import { render, staticRenderFns } from "./MenuSpacer.vue?vue&type=template&id=10ba448b&"
import script from "./MenuSpacer.vue?vue&type=script&lang=js&"
export * from "./MenuSpacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports